<div class="container">
    <div class="add-button" *ngIf="user && user.isSuperAdmin">
        <button mat-raised-button (click)="openAddReport()">Add Report <i-feather name="plus"></i-feather></button>
    </div>
    <div class="caption header8">
        {{plaintext.manageReports.select[user.language]}}
    </div>
    <div class="security-manager">
        <mat-progress-bar mode="indeterminate" *ngIf="isReportsLoading"></mat-progress-bar>
        <div *ngIf="!isReportsLoading">
            <mat-list class="reports-list">
                <mat-list-item class="report-list-item" *ngFor="let report of reports" (click)="selectReport(report)"
                    [class.selected]="selectedReport == report">
                    <i-feather class="nav-icon" name="bar-chart-2" class="chart-icon"></i-feather>
                    {{report.name}}
                    <i-feather *ngIf="report.synced != false && report.locked == true" class="new-icon" name="lock"
                        matTooltip="You do not have access to manage this report. You must be an owner of the report to manage it."
                        matTooltipPosition="right" [matTooltipClass]="{ 'btn-tooltip': true }"></i-feather>
                    <span *ngIf="report.synced == false" class="new-icon"
                        matTooltip="Report not synced. Click Manage Report to sync with Maxis for Dealers."
                        matTooltipPosition="right" [matTooltipClass]="{ 'btn-tooltip': true }">NEW</span>
                </mat-list-item>
            </mat-list>
            <div class="manager-buttons">
                <!-- <button mat-raised-button color="warn" [disabled]="!selectedReport">Remove Report</button> -->
                <button mat-raised-button class="close-button" routerLink="/reports">
                    Close
                </button>
                <button mat-raised-button color="accent" [disabled]="!selectedReport"
                    (click)="goToManageReport(selectedReport)" id="manageReportBtn">
                    Manage Report
                </button>
            </div>
        </div>
    </div>
</div>